'use client'

import { useActionState } from 'react'
import { useFormStatus } from 'react-dom'
import { signIn } from '@/lib/auth'

type Labels = { user: string; userPlaceholder: string; password: string; submit: string; working: string }

function Submit({ label, working }: { label: string; working: string }) {
  const { pending } = useFormStatus()
  return (
    <button type="submit" className="kt-btn-primary w-full" disabled={pending}>
      {pending ? working : label}
    </button>
  )
}

/**
 * ฟอร์มเข้าสู่ระบบ · แยกเป็นส่วนฝั่งเบราว์เซอร์เพราะต้องแสดงข้อความผิดพลาดและสถานะกำลังทำงาน
 * ข้อความผิดพลาดมาจากฝั่งเซิร์ฟเวอร์ ไม่ตัดสินถูกผิดในเบราว์เซอร์
 */
export function LoginForm({ labels }: { labels: Labels }) {
  const [state, action] = useActionState(signIn, {} as { error?: string })
  return (
    <form action={action} className="mt-7 space-y-4">
      {state?.error && (
        <p role="alert" className="rounded-lg bg-kt-bad-soft px-3 py-2.5 text-sm text-kt-bad">{state.error}</p>
      )}
      <div>
        <label className="kt-label" htmlFor="identifier">{labels.user}</label>
        <input id="identifier" name="identifier" className="kt-input" placeholder={labels.userPlaceholder} autoComplete="username" required />
      </div>
      <div>
        <label className="kt-label" htmlFor="password">{labels.password}</label>
        <input id="password" name="password" type="password" className="kt-input" autoComplete="current-password" required />
      </div>
      <Submit label={labels.submit} working={labels.working} />
    </form>
  )
}
